import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Rimuoviamo HelmetProvider per ora: è lui che sta causando l'errore 
// "A React Element from an older version of React was rendered"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);